import { NgModule } from '@angular/core';

import { SidebarComponent } from './sidebar.component';

@NgModule({
    imports: [],
    exports: [
        SidebarComponent,
        SidebarComponent
    ],
    declarations: [SidebarComponent],
    providers: [],
})
export class SidebarModule { }
